import { createBlueprint as e } from "@made-people/blueprint";
const l = e({
  slots: {
    wrapper: "",
    logosWrapper: "",
    logos: "",
    content: "",
    text: "",
    link: ""
  },
  variants: {
    layout: {
      vertical: {
        wrapper: "flex flex-col"
      },
      horizontal: {
        wrapper: "flex flex-row"
      },
      "horizontal-reverse": {
        wrapper: "flex flex-row-reverse"
      },
      "vertical-reverse": {
        wrapper: "flex flex-col-reverse"
      }
    }
  }
});
export {
  l as logosAndTextTemplate1Blueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
